"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _fill = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/fill"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _recharts = require("recharts");
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _RechartsTooltip = _interopRequireDefault(require("./RechartsTooltip"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "title": "area_chart-module__title___c2x7R",
  "container": "area_chart-module__container___fXmRU",
  "tooltip": "area_chart-module__tooltip___wLE64",
  "tooltip_circle": "area_chart-module__tooltip_circle___Zyp3f",
  "tooltip_bold": "area_chart-module__tooltip_bold___YZ2nh",
  "tooltip_text": "area_chart-module__tooltip_text___I6Jpd",
  "tooltip_link": "area_chart-module__tooltip_link___fXyqY"
};
const CHART_HEIGHT = 108;
class AreaChart extends _react.default.Component {
  static propTypes = {
    data: T.array.isRequired,
    height: T.number,
    margin: T.object,
    gradient: T.bool,
    seriesColors: T.arrayOf(T.shape({
      stroke: T.string,
      fill: T.string
    })),
    seriesLabels: T.arrayOf(T.string),
    width: T.oneOfType([T.number, T.string]),
    xAxis: T.oneOfType([T.arrayOf(T.shape({
      dataKey: T.string,
      tickLine: T.bool,
      tick: T.object,
      color: T.string
    })), T.object]),
    yAxis: T.oneOfType([T.arrayOf(T.shape({
      dataKey: T.string,
      tickLine: T.bool,
      tick: T.object,
      color: T.string,
      axisLine: T.bool
    })), T.object]),
    titleString: T.string,
    titleId: T.string,
    dataMax: T.number,
    ticks: T.arrayOf(T.number),
    tickCount: T.number
  };
  static defaultProps = {
    height: CHART_HEIGHT,
    margin: {
      top: 96,
      right: 31,
      left: 0,
      bottom: 40
    }
  };
  calcTickCount(max) {
    if (!max) {
      return [null, null, null];
    }
    const {
      tickCount,
      ticks
    } = this.props;
    if (tickCount && ticks) {
      return [tickCount, ticks];
    }
    let tickC = 4;
    let yMax = max;
    let tick = [];
    if (ticks) {
      tickC = ticks.length;
      return [ticks, tickC];
    }
    if (tickCount) {
      tickC = tickCount;
    } else {
      yMax = Math.ceil(max / 4) * 4;
    }
    let val = 0;
    for (let i = 0; i <= tickC; i++) {
      tick.push(val);
      val += yMax / tickC;
    }
    return [tickC + 1, yMax, tick];
  }
  renderCharts() {
    const {
      seriesLabels = [],
      seriesColors,
      gradient,
      dataMax
    } = this.props;
    return (0, _map.default)(seriesLabels).call(seriesLabels, (label, idx) => /*#__PURE__*/_react.default.createElement(_recharts.Area, {
      key: `area-chart-${label}`,
      dataKey: label,
      yAxisId: dataMax ? idx % 2 == 0 ? 'right' : 'left' : undefined,
      stroke: seriesColors[idx].stroke,
      fill: gradient ? `url(#${(0, _fill.default)(seriesColors[idx])})` : (0, _fill.default)(seriesColors[idx])
    }));
  }
  renderGradients() {
    const {
      seriesColors
    } = this.props;
    let gradients = [];
    for (let colors in seriesColors) {
      const gradient = /*#__PURE__*/_react.default.createElement("linearGradient", {
        key: `linear-gradient-${(0, _fill.default)(seriesColors[colors])}`,
        id: (0, _fill.default)(seriesColors[colors]),
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 1
      }, /*#__PURE__*/_react.default.createElement("stop", {
        offset: "0%",
        stopColor: (0, _fill.default)(seriesColors[colors]),
        stopOpacity: 0.5
      }), /*#__PURE__*/_react.default.createElement("stop", {
        offset: "100%",
        stopColor: '#ffffff',
        stopOpacity: 0.1
      }));
      gradients.push(gradient);
    }
    return gradients;
  }
  render() {
    const {
      data,
      height,
      width,
      margin,
      dataMax,
      gradient,
      titleString,
      titleId
    } = this.props;
    const xAxisProps = this.props.xAxis;
    const yAxisProps = this.props.yAxis;
    const [tickCount, yMax, ticks] = this.calcTickCount(dataMax);
    return /*#__PURE__*/_react.default.createElement(_recharts.ResponsiveContainer, {
      width: width,
      height: height,
      className: styles.container
    }, /*#__PURE__*/_react.default.createElement(_recharts.AreaChart, {
      width: width,
      height: height,
      data: data,
      margin: margin
    }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("foreignObject", {
      x: 32,
      y: 32,
      width: width,
      height: 32
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: styles.title,
      displayString: titleString,
      displayId: titleId
    }))), gradient && /*#__PURE__*/_react.default.createElement("defs", null, this.renderGradients()), /*#__PURE__*/_react.default.createElement(_recharts.XAxis, xAxisProps), dataMax && /*#__PURE__*/_react.default.createElement(_recharts.YAxis, (0, _extends2.default)({
      domain: [0, yMax],
      ticks: ticks,
      tickCount: tickCount,
      yAxisId: "right",
      orientation: "right"
    }, yAxisProps)), dataMax && /*#__PURE__*/_react.default.createElement(_recharts.YAxis, (0, _extends2.default)({
      domain: [0, yMax],
      ticks: ticks,
      tickCount: tickCount,
      yAxisId: "left",
      orientation: "left"
    }, yAxisProps)), !dataMax && /*#__PURE__*/_react.default.createElement(_recharts.YAxis, (0, _extends2.default)({
      tickLine: false
    }, yAxisProps)), /*#__PURE__*/_react.default.createElement(_recharts.CartesianGrid, {
      domain: dataMax ? [0, yMax] : undefined,
      vertical: false
    }), /*#__PURE__*/_react.default.createElement(_recharts.Tooltip, {
      content: /*#__PURE__*/_react.default.createElement(_RechartsTooltip.default, null)
    }), this.renderCharts()));
  }
}
exports.default = AreaChart;